/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsServerNetworkMinus: {
  name: 'server-network-minus';
  data: string;
} = {
  name: 'server-network-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 2A1.5 1.5 0 0 1 4 .5h8A1.5 1.5 0 0 1 13.5 2v6A1.5 1.5 0 0 1 12 9.5H4A1.5 1.5 0 0 1 2.5 8V2ZM4 1.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H4Zm2 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6Zm-5 10a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1H1ZM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
